import { render, staticRenderFns } from "./deanTooltip.vue?vue&type=template&id=51d2056e&scoped=true"
import script from "./deanTooltip.vue?vue&type=script&lang=ts"
export * from "./deanTooltip.vue?vue&type=script&lang=ts"
import style0 from "./deanTooltip.vue?vue&type=style&index=0&id=51d2056e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2056e",
  null
  
)

export default component.exports